var map = {
	"./auth/i18n/lang.json": 41213,
	"./billing/i18n/lang.json": 98758,
	"./cam/i18n/lang.json": 70606,
	"./care-sheet/i18n/lang.json": 61432,
	"./certificate/i18n/lang.json": 6378,
	"./consultation/i18n/lang.json": 49190,
	"./dental-consultation/i18n/lang.json": 25715,
	"./exam/i18n/lang.json": 67268,
	"./example-module/i18n/lang.json": 8774,
	"./forms/i18n/lang.json": 58910,
	"./frontdesk/i18n/lang.json": 42639,
	"./general-payment/i18n/lang.json": 24922,
	"./generic-states/i18n/lang.json": 89133,
	"./hospitalization/i18n/lang.json": 19719,
	"./medical-care/i18n/lang.json": 65044,
	"./oximetry/i18n/lang.json": 15590,
	"./parameters/i18n/lang.json": 61439,
	"./patient/i18n/lang.json": 11040,
	"./payment/i18n/lang.json": 61279,
	"./prescription/i18n/lang.json": 20187,
	"./rehabilitation/i18n/lang.json": 9250,
	"./shared/i18n/lang.json": 96838,
	"./specifics/i18n/lang.json": 22640,
	"./stand-alone/i18n/lang.json": 62939,
	"./stock/i18n/lang.json": 27307,
	"./visit/i18n/lang.json": 5398,
	"./workflow/i18n/lang.json": 72674,
	"auth/i18n/lang.json": 41213,
	"billing/i18n/lang.json": 98758,
	"cam/i18n/lang.json": 70606,
	"care-sheet/i18n/lang.json": 61432,
	"certificate/i18n/lang.json": 6378,
	"consultation/i18n/lang.json": 49190,
	"dental-consultation/i18n/lang.json": 25715,
	"exam/i18n/lang.json": 67268,
	"example-module/i18n/lang.json": 8774,
	"forms/i18n/lang.json": 58910,
	"frontdesk/i18n/lang.json": 42639,
	"general-payment/i18n/lang.json": 24922,
	"generic-states/i18n/lang.json": 89133,
	"hospitalization/i18n/lang.json": 19719,
	"medical-care/i18n/lang.json": 65044,
	"oximetry/i18n/lang.json": 15590,
	"parameters/i18n/lang.json": 61439,
	"patient/i18n/lang.json": 11040,
	"payment/i18n/lang.json": 61279,
	"prescription/i18n/lang.json": 20187,
	"rehabilitation/i18n/lang.json": 9250,
	"shared/i18n/lang.json": 96838,
	"specifics/i18n/lang.json": 22640,
	"stand-alone/i18n/lang.json": 62939,
	"stock/i18n/lang.json": 27307,
	"visit/i18n/lang.json": 5398,
	"workflow/i18n/lang.json": 72674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12955;